export const increaseState = (state) => (state += 1);
export const decreaseState = (state) => (state -= 1);
